import { ref, get, set, update } from 'firebase/database';
import { database } from './firebaseConfig';
import { IGameLimitService } from '../../app/ports/IGameLimitService';

const MONTHLY_LIMIT = 100;

function getCurrentMonth(): string {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}

export class FirebaseGameLimitService implements IGameLimitService {
  private getPath(userId: string): string {
    return `gameLimits/${userId}/${getCurrentMonth()}`;
  }

  async getMonthlyCount(userId: string): Promise<number> {
    const snap = await get(ref(database, this.getPath(userId)));
    return snap.exists() ? (snap.val() as number) : 0;
  }

  async incrementCount(userId: string): Promise<void> {
    const current = await this.getMonthlyCount(userId);
    await set(ref(database, this.getPath(userId)), current + 1);
  }

  async hasReachedLimit(userId: string): Promise<boolean> {
    const count = await this.getMonthlyCount(userId);
    return count >= MONTHLY_LIMIT;
  }
}
